import { supabase } from '@/lib/supabase';
import type { AuditEvent } from '@/lib/types';

/**
 * Audit log helpers (Day 9).
 *
 * Reads route through audit_events_for_org() so the function can guard the
 * caller is owner/platform-admin and so we can write an AUDIT_VIEWED row
 * each time the page is opened.
 */

export interface AuditPage {
  rows: AuditEvent[];
  total: number;
  limit: number;
  offset: number;
}

export async function listAuditEvents(
  limit = 50,
  offset = 0,
  orgId: string | null = null
): Promise<AuditPage> {
  const { data, error } = await supabase.rpc('audit_events_for_org', {
    p_org_id: orgId,
    p_limit: limit,
    p_offset: offset,
  });
  if (error) throw error;
  const rows = (data ?? []) as AuditEvent[];
  const total = rows.length > 0 ? Number(rows[0].total_count ?? rows.length) : 0;
  return { rows, total, limit, offset };
}

export async function acceptDpa(version = '2026.05.06'): Promise<void> {
  const { error } = await supabase.rpc('dpa_accept', { p_version: version });
  if (error) throw error;
}

/** Friendly labels for the audit event_type column. */
export function formatEventType(t: string): string {
  return t
    .toLowerCase()
    .split('_')
    .map((s) => s[0]?.toUpperCase() + s.slice(1))
    .join(' ');
}
